<template>
    <header class="header">
        <div class="wp">
            <div class="left">
                <a href="https://www.atlascopco.com.cn/zh-cn/itba" title="Atlas Copco: Home of industrial ideas - 阿特拉斯·科普柯中国" target="_blank">
                    <img src="../assets/logo.png" alt="Atlas Copco: Home of industrial ideas - 阿特拉斯·科普柯中国" class="logo">
                </a>
                <a class="about-text" href="https://www.atlascopco.com.cn/zh-cn/itba/ContactUs" target="_blank">联系我们</a>
            </div>
            <div class="text">
                SQS ROI实时计算
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'HeaderDefault'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    @import "../style/color.scss";

    .header {
        height: 110px;
        background-color: #fff;
        border-bottom: 1px solid #bfbfbf;

        .wp {
            display: flex;
            height: 110px;
            padding: 0 10px;
            align-items: center;
            justify-content: space-between;
        }
        .left{
            display: flex;
            align-items: center;
        }
        .logo {
            height: 51.333px;
            margin: 0 20px;
            display: block;
        }
        .about-text{
            padding-left: 10px;
            color: $main-color;
            font-size: 18px;
            text-decoration: underline;
            @media (max-width: 900px) {
                font-size: 16px;
                padding-left: 10px;
            }
        }

        .text {
            color: $main-color;
            font-size: 24px;
        }

        @media (max-width: 900px) {
            height: 60px;
            .wp {
                height: 60px;
            }
            .text {
                font-size: 18px;
            }
            .logo {
                height: 28px;
                margin: 0 6px;
            }
        }
    }
</style>
